import Axios from '@/services/axios-instance/axios.service';
const API_URL = process.env.NODE_ENV !== 'development' ? `${window.location.origin}/api` : 'http://localhost:5000/api';

class ReapplyService {
  async getReapplyInfo(id) {
    const { data } = await Axios.get(`${API_URL}/reapply/${id}`);
    return data;
  }
  async submitReapplyInfo(id, form) {
    const { data } = await Axios.post(`${API_URL}/reapply/${id}`, form);
    return data;
  }
}

export default new ReapplyService();
